import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider, createTheme } from '@mui/material';
import { Provider } from 'react-redux';
import store from './store/store';
import { Light } from '@mui/icons-material';

const respIconButton = {
    '@media (min-width: 1000px)': { fontSize: '6vw' },
    '@media (orientation: landscape)': { fontSize: '1.5rem' },
};

const theme = createTheme({
    palette: {
        primary: {
            light: '#17468C',
            main: '#082C91',
            dark: '#262673',
            contrastText: '#FFFFFF',
        },
        secondary: {
            light: '#747676',
            main: '#747676',
            dark: '#747676',
            contrastText: '#ffffff',
        },
        c_mono: {
            main: '#FFF',
            contrastText: '#000',
        },
        c_title: {
            main: '#FFE04D',
        },
        c_yellow: {
            main: '#FFE04D',
            contrastText: '#1A204D'
        },
        c_button: {
            main: '#969EB6',
            bg: '#526AAD',
            contrastText: '#FFE04D'
        },
        c_button_exit: {
            light: '#000000',
            main: '#a8b5d6',
            contrastText: '#FFF'
        },
    },
    typography: {
        allVariants: {
            color: '#082C91'
        },
        fontFamily: [
            'IBM Plex Sans Thai Looped'
        ]
    },
    components: {
        MuiIconButton: {
            variants: [
                {
                    props: { variant: 'resp' },
                    style: respIconButton,
                },
                {
                    props: { variant: 'resp0' },
                    style: {
                        ...respIconButton,
                        
                    }
                },
                {
                    props: { variant: 'resp1' },
                    style: {
                        ...respIconButton,
                        color:"#FFE04D",
                        backgroundColor:"#526AAD",
                        "&:hover": {
                            color:"#FFE04D",
                            backgroundColor:"#526AAD",
                        },
                    }
                },
                {
                    props: { variant: 'respSimp0' },
                    style: {
                        ...respIconButton,
                        color:"#969EB6",
                        "&:hover": { color:"#526AAD" }
                    }
                },
                {
                    props: { variant: 'respSimp1' },
                    style: {
                        ...respIconButton,
                        color:"#17468C",
                        "&:hover": { color:"#526AAD" }
                    }
                },
                {
                    props: { variant: 'respSimpStatic' },
                    style: {
                        ...respIconButton,
                        color:"#747676",
                    }
                },
            ],
        },
    },
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
